module.exports = __webpack_public_path__ + "img/rud.ee22f2c4.webp";